import useWeakMap from "../../../utils/useWeakMap";
import useWeakSet from "../../../utils/useWeakSet";
import { isLayer } from "../validator/useLayerIdentity";
import useLogStack from "../../utils/useLogStack";


const store = useWeakMap();

export const storeParentLayer = (layer, parentLayer) => {
    if (!isLayer(layer) || !isLayer(parentLayer)) 'Only allow layer';
    if (layer === parentLayer) return;
    useLogStack("storeParentLayer", layer, parentLayer)
    store.set(layer, parentLayer);
}


/**
 * 
 * @param {object} layer 
 * @returns  {Set<object> | undefined}
 */
const useQueryParentLayer = (layer) => {
    return store.get(layer);
}

export const lookupParentLayer = function* (layer) {
    let parent;
    while (true) {
        parent = store.get(layer);
        if (!parent) break
        yield parent;
        layer = parent;
    }
}

export default useQueryParentLayer